import { memberGQLFields } from '../network/member.fields.js';
import { spaceGQLFields } from './space.fields.js';
import { spaceRoleGQLFields } from './spaceRole.fields.js';
const BASIC_SPACE_MEMBER_FIELDS = {};
const ALL_SPACE_MEMBER_FIELDS = {
    member: 'basic',
    role: 'basic',
    space: 'basic',
};
export function spaceMemberGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_SPACE_MEMBER_FIELDS;
    if (fields === 'all')
        fields = ALL_SPACE_MEMBER_FIELDS;
    return `
    __typename
    ${fields.member
        ? `
      member {
        ${memberGQLFields(fields.member)}
      }
    `
        : ``}
    ${fields.role
        ? `
      role {
        ${spaceRoleGQLFields(fields.role)}
      }
    `
        : ``}
    ${fields.space
        ? `
        space {
          ${spaceGQLFields(fields.space)}
        }
    `
        : ``}
  `;
}
//# sourceMappingURL=spaceMember.fields.js.map